import type { AiContextType } from "../../../../AiToolboxSection.context";

export const AI_CONTEXT_BADGE_TYPE_COLORS: Record<AiContextType, string> = {
  "selected-metric": "bg-primary-lightest text-primary-dark border-primary-light",
  "selected-task": "bg-info-lightest text-info-dark border-info-light",
  "selected-alert": "bg-warning-lightest text-warning-dark border-warning-light",
  "selected-row": "bg-neutral-lightest text-dark border-neutral-light",
  "error-message": "bg-error-lightest text-error-dark border-error-light",
  incident: "bg-warning-lightest text-warning-dark border-warning-light",
  "highlighted-text": "bg-success-lightest text-success-dark border-success-light",
  custom: "bg-neutral-lightest text-dark border-neutral-light",
};
